import { Img } from "components/Img";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const NewGoogleAuth = () => {

    const [searchParams] = useSearchParams();
    const isError = searchParams?.get('error');

    const code = searchParams?.get('code');
    const state = searchParams?.get('state');

    function saveAndRedirect() {
        const data = JSON.stringify({
            DATA: {
                "AUTHORIZATION_CODE": code,
                "STATE": state,
                "SERVICE": "",
            },
            URL: 'google/list?env=onboarding'
        });
        const channel = new BroadcastChannel('popup_channel');
        channel.postMessage(data); // Send data to the parent
        channel.close(); // Close the channel after sending the message
        window.close();
    }

    useMemo(() => {
        if (!!code && !!state) {
            setTimeout(() => saveAndRedirect(), 2000);
        }
    }, [code, state]);


    // const HandleClose = () => {
    //     // const urlParams = new URLSearchParams(window.location.search);
    //     // const code = urlParams.get('code');

    //     // // window.opener.postMessage({ code }, 'https://d1g6axlwnukooh.cloudfront.net/');

    //     if (!isError) {
    //         const data = JSON.stringify({
    //             DATA: {
    //                 "AUTHORIZATION_CODE": code,
    //                 "STATE": state,
    //                 "SERVICE": "",
    //             },
    //             URL: 'google/list?env=onboarding'
    //         });
    //         const channel = new BroadcastChannel('popup_channel');
    //         channel.postMessage(data); // Send data to the parent
    //         channel.close(); // Close the channel after sending the message
    //     }

    //     window.close();
    // }


    return (
        !!code ? <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg relative max-w-[500px] flex flex-col items-center justify-center">
                <div className="flex gap-2 items-center">
                    <Img src="/images/Logo.svg" className="w-5 h-5" />
                    <p className="text-xl">⇄</p>
                    <Img src="/images/Google.svg" className="w-5 h-5" />
                </div>
                <h2 className="text-xl font-bold mb-4 break-words">Hooray! Google authentication was successful.</h2>
                <h2 className="text-sm font-bold mb-4 break-words">You can now start sharing your videos to Youtube channel.</h2>
                <h2 className="text-sm font-bold mb-4 break-words">Redirecting you to the app. Please wait...</h2>
                {/* <button
                    className="text-sm font-semibold text-white bg-blue-500 px-4 py-2 rounded-md mt-4"
                    onClick={HandleClose}
                >
                    Close
                </button> */}
            </div>
        </div> : <></>
    );
}

export default NewGoogleAuth;